import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual } from "lodash";

import 'react-tabs/style/react-tabs.css';

import * as PD from '../classes/pdStyle';
import {cloneObject, getParam} from '../utils/utils';


import dsd from "../classes/clsDSD";
import {listResources} from '../utils/utilsResource';

import { Plus, Trash } from 'react-bootstrap-icons';

class StepResourceRow extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            mode: 'view',
            renderState: null
        };


        this.data = {};

        this.handleChange = this.handleChange.bind(this);
        this.handleButton = this.handleButton.bind(this);
        this.updateParent = this.updateParent.bind(this);


        this.dsd = new dsd();
        this.dsd.StateObject = this;

        this.FallBackNavigation = `.`;


    }

    componentDidMount(){

       this.setup();

    }

    componentDidUpdate(prevProps, prevState){

        if (!isEqual(this.props, prevProps)){
            this.setup();
        }

    }
    
    setup(){

        let StateChange = {

            renderState: null,

            FormData: {},

            Resource: null,
            seq: null,

            parent: null,

            optResources: null,

            selectedResource: null
        }

        StateChange.parent = getParam('parent', this.props);
        StateChange.mode = getParam('mode', this.props);

        StateChange.Resource = getParam('Resource', this.props);
        if (isNull(StateChange.Resource)){
            StateChange.Resource = {};
        }
        StateChange.FormData = cloneObject(StateChange.Resource);
        StateChange.seq = getParam('seq', this.props);


        if (StateChange.mode == null){
            StateChange.mode = 'edit';
        }

        this.setState(StateChange);

        this.loadResources();
        
    }

    loadResources(){

        this.setState({renderState: "loading"});

        const onLoad = (Resources) => {
            this.setState({
                optResources: Resources,
                renderState: "loaded"
            });
        };

        const onError = (error) => {
            this.setState({
                renderState: "failed",
                errorMessage: error.message || "Failed to load resources"
            });
        };

        listResources(this.dsd, {}, onLoad, onError);

    }

    handleButton(event) {
    
        let StateChange = {};

        switch (event.currentTarget.name){
            case 'btnAdd':
                StateChange.mode = 'edit';
                this.state.parent.addResource();
                break;
            case 'btnDelete':
                this.state.parent.removeResource(this.state.seq);
                break;
    
        }
    
        this.setState(StateChange);
    
        event.preventDefault();    

    };


    handleChange(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        let FormData = this.state.FormData;
        FormData[FormFieldName] = FormFieldValue;

        this.setState({"FormData": FormData});

    };

    updateParent(){
        this.state.parent.updateResource(this.state.seq, this.state.FormData);
        return;
    }


    render() {

        if (this.state.renderState === "failed") {
            return <PD.ErrorBox>ERROR - Failed to Load</PD.ErrorBox>
        }

        if (this.state.renderState === "loading") {
            return null;
        }

        if (this.state.renderState === "loaded") {

            switch (this.state.mode){
                case 'new':
                case 'edit':
                    return (
                        <PD.Tr>
                            <PD.Td>
                                {(() => {
                                    switch (this.state.mode) {
                                        case "new": 
                                            return <button name="btnAdd" onClick={this.handleButton}><Plus/></button>;
                                        case "edit": 
                                            return <button name="btnDelete" onClick={this.handleButton}><Trash/></button>;
                                    }
                                })()}
                            </PD.Td>
                            {this.state.mode == 'edit' &&
                                <React.Fragment>
                                    <PD.Td>

                                        <PD.Select label='Resource' name='idResource'  onChange={this.handleChange} onBlur={this.updateParent} value={this.state.FormData.idResource}>
                                            {
                                                this.state.optResources.map(
                                                (optResource, posOptResource) => 
                                                    {
                                                        let optModelResource = null;
                                                        if (optResource.type in this.dsd.model.resources){
                                                            optModelResource = this.dsd.model.resources[optResource.type];
                                                        }
                                                        return (
                                                            <option key={posOptResource} value={optResource.id}>{optResource.name}</option>
                                                        )
                                                    }
                                                )
                                            }
                                        </PD.Select>
                                        <PD.Input label='relevance' name="relevance" width="30" value={this.state.FormData.relevance} onChange={this.handleChange} onBlur={this.updateParent}/>
                                        <PD.Input label='URL' name="URL" width="30" value={this.state.FormData.URL} onChange={this.handleChange} onBlur={this.updateParent}/>
                                    </PD.Td>

                                </React.Fragment>
                            }
                        </PD.Tr>
                    );
                    break;
            };
        };

        return null;
    };
};

// Wrap and export
export default function StepResourceRow_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <StepResourceRow {...props} navigation={navigation} location={location} params={params} />;
  }
